import TransitionsModal from './TransitionModal';

export {
  TransitionsModal,
};
export default {
  TransitionsModal,
};
